import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InnerDrawerWrapper = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  min-height: ${props => (props.screenHeight ? `${props.screenHeight}px;` : '100vh;')};
  width: 100vw;
  overflow-y: scroll;
  -webkit-overflow-scrolling:touch;
`;

const InnerDrawer = ({ children, className, screenHeight }) => (
  <InnerDrawerWrapper className={className} screenHeight={screenHeight}>
    {children}
  </InnerDrawerWrapper>
);

InnerDrawer.defaultProps = {
  className: '',
  screenHeight: null,
};

InnerDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  screenHeight: PropTypes.number,
};

export default InnerDrawer;
